import { IJPlistItem } from '../artists-jplist-interfaces';
import { IGNORE_REGEX } from '../artists-jplist';

/**
 * text filter
 * this filter returns all items that contains the specified text in the given path
 * property - any item property; empty value meaning the whole element; 'default' means no change
 * mode - contains (default), startsWith, endsWith, equal
 * ignoreRegex - optional regex that defines what characters should be ignored
 * returns filtered items
 */
export const textFilter = (
    items: IJPlistItem[],
    text: string,
    property: string='',
    mode: string = 'contains',
    ignoreRegex: string = IGNORE_REGEX) =>{

    const filtered = [];

    if(!items) return [];

    // no change is needed
    if(property === 'default') return items;

    const formattedText = text.replace(new RegExp(ignoreRegex, 'ig'), '').toLowerCase().trim();

    for(let item of items){

        const value = (property === '' ) ? item : item[property];
        let shouldBeAdded = false;
        const itemText = value.replace(new RegExp(ignoreRegex, 'ig'), '').toLowerCase().trim();

        switch(mode){

            case 'startsWith':{
                if(itemText.startsWith(formattedText)){
                    shouldBeAdded = true;
                }
                break;
            }

            case 'endsWith':{
                if(itemText.endsWith(formattedText)){
                    shouldBeAdded = true;
                }
                break;
            }

            case 'equal':{
                if(itemText === formattedText){
                    shouldBeAdded = true;
                }
                break;
            }

            default:{
                //contains
                if(itemText.indexOf(formattedText) !== -1){
                    shouldBeAdded = true;
                }
                break;
            }
        }

        if(shouldBeAdded){
            filtered.push(item);
        }
    }

    return filtered;
};
